import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {SignupState, UserService} from '../../services/user.service';
import {ButtonDirective} from "primeng/button";
import {initialSignupRoute} from "../../pages/signup/specific-signup.routes";
import {RouterLink} from "@angular/router";
import {loginRoute} from "../../app.routes";
import {signupPaymentStartRoute} from "../../pages/signup-section/signup-route-values";


@Component({
  selector: 'homey-signup-button',
  imports: [
    ButtonDirective,
    RouterLink
  ],
  templateUrl: './signup-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'block',
    '[class.w-full]': "this.wide()",
    '[class.max-w-60]': "this.wide()"
  }
})
export class SignupButtonComponent {
  public readonly signupText = input('Try for free')
  public readonly severity = input<'info' | 'primary' | 'secondary'>('primary');
  public readonly wide = input<boolean>(false);
  public readonly bolder = input<boolean>(false);
  public readonly size = input<'small'>();
  public readonly routeQueryParams = input<Record<string, unknown>>({});
  public readonly defaultSignupRoute = input<string[]>(initialSignupRoute);

  private readonly userService = inject(UserService);

  protected readonly signupState = this.userService.signupState;
  protected readonly route = computed(() => {
    const state = this.signupState();

    switch (state) {
      case 'not-signed-up':
        return this.defaultSignupRoute();
      case 'in-signup-flow':
        return signupPaymentStartRoute;
      case 'previously-signed-up':
        return loginRoute;
      case 'previously-paid':
        return loginRoute;
      case 'active':
        return ['/'];
    }
  });

  protected readonly stateMapping: Record<Exclude<SignupState, 'not-signed-up'>, string> = {
    "in-signup-flow": "Complete signup",
    "previously-signed-up": "Complete signup",
    "previously-paid": "Login",
    active: "Continue"
  }
  protected readonly initialSignupRoute = initialSignupRoute;
}
